import { getHSLAString } from "@aichat/aichat-lib";
import { WidgetConfig } from "@aichat/types/widget";
import { cn } from "@aichat/ui/lib/utils";
import { MicIcon, SquareIcon } from "lucide-react";

interface IVoiceButtonProps {
  onClick: () => void;
  config: WidgetConfig;
  isAvatarTalking?: boolean;
}

export default function VoiceButton({
  config,
  onClick,
  isAvatarTalking,
}: IVoiceButtonProps) {
  const brandHSLAString = getHSLAString(config.brandColor);
  return (
    <div className={cn(config.isThemeSleek ? "me-3" : "")}>
      <button
        type="button"
        onClick={onClick}
        className={cn(
          "h-10 w-10 border bg-white hover:bg-gray-100 rounded-full grid place-items-center transition-all duration-300",
          {
            "bg-transparent border-none": config.isThemeSleek,
          },
        )}
      >
        {isAvatarTalking ? (
          <SquareIcon color={brandHSLAString} />
        ) : (
          <MicIcon color={brandHSLAString} />
        )}
      </button>
    </div>
  );
}
